import { cn } from "@/shared/lib/css";

import { formatPrice } from "../lib/format-price";

interface PriceProps {
  cents: number;
  className?: string;
}

export function Price({ cents, className }: PriceProps) {
  return <span className={cn(className)}>{formatPrice(cents)}</span>;
}
